module.exports = __webpack_public_path__ + "img/vida-verd-03.98fb4c83.jpg";